import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NoteRegularAi from './note-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NoteRegularAi {...validProps} />;
}
SvgComponent.iconName = 'noteRegularAi';

export const NoteRegularAiIcon = svgIconWrapper(SvgComponent);
